import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentmanager',
  templateUrl: './documentmanager.component.html',
  //styleUrls: ['./documentmanager.component.css']
})
export class DocumentmanagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
